// extracted by mini-css-extract-plugin
export default {"fileContainer":"Izvestaji_fileContainer__btpJv","prazno":"Izvestaji_prazno__F-iAj"};